import { Slot } from '@radix-ui/react-slot';
import { type VariantProps, cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

const buttonVariants = cva('button block w-full text-center', {
    variants: {
        variant: {
            active: 'border-2 border-haug-lila-100 bg-haug-lila-100 text-white hover:bg-haug-lila-200',
            outline:
                'border-2 border-haug-lila-100 text-haug-lila-100 hover:bg-haug-lila-100 hover:text-white',
            upcoming: 'border-2 border-haug-lila-100 bg-haug-lila-100 text-white',
            'almost-sold-out': 'border-2 border-haug-blue-100 bg-haug-blue-100 text-white',
            'sold-out': 'border-2 border-haug-coral-100 text-haug-coral-100',
            cancelled: 'border-2 border-haug-coral-100 text-haug-coral-100',
            'white-outline': 'border-2 border-haug-ivory-100 text-haug-ivory-100',
        },
        disabled: {
            true: 'disabled',
        },
        size: {
            sm: 'text-sm',
            md: 'text-base',
            lg: 'text-lg',
            icon: 'h-10 w-10 p-0 text-base',
        },
    },
    defaultVariants: {
        variant: 'active',
        disabled: false,
    },
});

export interface ButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement>,
        Omit<VariantProps<typeof buttonVariants>, 'disabled'> {
    asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ className, variant, size, asChild = false, ...props }, ref) => {
        const Comp = asChild ? Slot : 'button';
        return (
            <Comp
                className={cn(buttonVariants({ variant, size, className }))}
                ref={ref}
                {...props}
            />
        );
    }
);
Button.displayName = 'Button';

export { Button, buttonVariants };
